
class Permission {
    constructor({
      user,
      project,
      permissions
    }) {
      this.user = user;
      this.project = project;
      this.permissions = permissions;
    }
  
  }
  
  export default Permission;
  